module.exports = __webpack_public_path__ + "static/media/troublemaker.dac79b04.jpg";